module.exports = __webpack_public_path__ + "img/694.1c61875a.png";